document.addEventListener("DOMContentLoaded", function () {

    var defaultRadioButton = document.getElementById('style-first_style');
    defaultRadioButton.checked = true;
    function showHideImages(selectedValue) {
        console.log('call', selectedValue)
      
        var sliderItems = document.querySelectorAll('.slider__item');
        sliderItems.forEach(function (item) {
            var dataAlt = item.getAttribute('data-alt');
            if (dataAlt === selectedValue) {
                // document.querySelector('li.slider__item[data-alt="'+selectedValue+'"] a')?.click();
              // $('.main-image .slider__item[data-alt="'+selectedValue+'"]').show()
                // document.querySelector('carousel-slider')?.refresh()
                // item.style.display = "block";
                // item.children[0].style.display = "block";
            } else {
                // item.style.display = "none";
                // item.children[0].style.display = "none";
              // $('.main-image .slider__item:not([data-alt="'+selectedValue+'"])').hide();
            }
        });
        if($('.main-hidden-slider').find('[data-alt="'+selectedValue+'"]').length > 0){
          console.log($('.main-hidden-slider').find('[data-alt="'+selectedValue+'"]').length)
          let htmlContent = '';
          $('.main-hidden-slider').find('[data-alt="'+selectedValue+'"]').each(function() {
            htmlContent += $(this).html();
          });
        
          $('.media-gallery__inner .main-slider .slider__grid-new').slick('unslick')
          $('.media-gallery__inner .main-slider .slider__grid-new').html(htmlContent);
          $('.media-gallery__inner .main-slider .slider__grid-new').slick({
            infinite: false,
            slidesToShow: 1,
            arrows: false,
            adaptiveHeight: true,
            slidesToScroll: 1,
            asNavFor: '.media-gallery__inner .thumbnails-slider .slider__grid-new'
          });
          $('.media-gallery__inner .main-slider .slider__grid-new').slick('slickGoTo', 0);
        }
        if($('.thumbnail-hidden-slider').find('[data-alt="'+selectedValue+'"]').length > 0 ){
          console.log($('.thumbnail-hidden-slider').find('[data-alt="'+selectedValue+'"]').length)
          $('.media-gallery__inner .thumbnails-slider .slider__grid-new').slick('unslick');
          let htmlContent = '';
          $('.thumbnail-hidden-slider').find('[data-alt="'+selectedValue+'"]').each(function() {
            htmlContent += $(this).html();
          });
          $('.media-gallery__inner .thumbnails-slider .slider__grid-new').html(htmlContent);
          $('.media-gallery__inner .thumbnails-slider .slider__grid-new').slick({
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: false,
            asNavFor: '.media-gallery__inner .main-slider .slider__grid-new',
            vertical: true,
            verticalSwiping: true,
            focusOnSelect: true,
            responsive: [
              {
                breakpoint: 767,
                settings: {
                  vertical: false,
                  verticalSwiping: false
                }
              }
            ]
          
          });
          $('.media-gallery__inner .thumbnails-slider .slider__grid-new').slick('slickGoTo', 0);
        }
        
        
    }
    var defaultSelectedValue = document.querySelector('label[for="' + defaultRadioButton.id + '"]').getAttribute('data-related-media');
    // showHideImages(defaultSelectedValue);
    var radioButtonsdata = document.querySelectorAll('input[type="radio"][name="properties[Style]"]');
    radioButtonsdata.forEach(function (radio) {
        radio.addEventListener("change", function () {
            var selectedValue = document.querySelector('label[for="' + this.id + '"]').getAttribute('data-related-media');
            if (selectedValue === null) {
                selectedValue = 'style-business-casual';
            }
            showHideImages(selectedValue);
        });
    });
});
$(document).ready(function(){
  $('.media-gallery__inner .main-slider .slider__grid-new').slick({
    infinite: false,
    slidesToShow: 1,
    arrows: false,
    adaptiveHeight: true,
    slidesToScroll: 1,
    asNavFor: '.media-gallery__inner .thumbnails-slider .slider__grid-new'
  });
  $('.media-gallery__inner .thumbnails-slider .slider__grid-new').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: '.media-gallery__inner .main-slider .slider__grid-new',
    vertical: true,
    verticalSwiping: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          vertical: false,
          verticalSwiping: false,
        }
      }
    ]
  
  });
  var defaultSelectedValue = document.querySelector('label[for="' + defaultRadioButton.id + '"]').getAttribute('data-related-media');


  if($('.main-hidden-slider').find('[data-alt="'+defaultSelectedValue+'"]').length > 0){
    console.log($('.main-hidden-slider').find('[data-alt="'+defaultSelectedValue+'"]').length)
    let htmlContent = '';
    $('.main-hidden-slider').find('[data-alt="'+defaultSelectedValue+'"]').each(function() {
      htmlContent += $(this).html();
    });
  
    $('.media-gallery__inner .main-slider .slider__grid-new').slick('unslick')
    $('.media-gallery__inner .main-slider .slider__grid-new').html(htmlContent);
    $('.media-gallery__inner .main-slider .slider__grid-new').slick({
      infinite: false,
      slidesToShow: 1,
      arrows: false,
      adaptiveHeight: true,
      slidesToScroll: 1,
      asNavFor: '.media-gallery__inner .thumbnails-slider .slider__grid-new'
    });
    $('.media-gallery__inner .main-slider .slider__grid-new').slick('slickGoTo', 0);
  }
  if($('.thumbnail-hidden-slider').find('[data-alt="'+defaultSelectedValue+'"]').length > 0 ){
    console.log($('.thumbnail-hidden-slider').find('[data-alt="'+defaultSelectedValue+'"]').length)
    $('.media-gallery__inner .thumbnails-slider .slider__grid-new').slick('unslick');
    let htmlContent = '';
    $('.thumbnail-hidden-slider').find('[data-alt="'+defaultSelectedValue+'"]').each(function() {
      htmlContent += $(this).html();
    });
    $('.media-gallery__inner .thumbnails-slider .slider__grid-new').html(htmlContent);
    $('.media-gallery__inner .thumbnails-slider .slider__grid-new').slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.media-gallery__inner .main-slider .slider__grid-new',
      vertical: true,
      arrows: false,
      verticalSwiping: true,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            vertical: false,
            verticalSwiping: false
          }
        }
      ]
    
    });
    $('.media-gallery__inner .thumbnails-slider .slider__grid-new').slick('slickGoTo', 0);
  }
  // $('.media-gallery__inner .main-slider .slider__grid-new').slick('slickFilter', '[data-alt="'+defaultSelectedValue+'"]');
  // $('.media-gallery__inner .thumbnails-slider .slider__grid-new').slick('slickFilter', '[data-alt="'+defaultSelectedValue+'"]');
})